<div class="sp-dialog__max-width-s sp-dialog__min-width">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div class="sp-padding__x2">
    <h3 class="sp-color__primary sp-margin__bottom-x2">
      {{ 'SHARED.TOOLBAR_VOP_REQUEST_CHECK_IBAN_LABEL' | translate }}
    </h3>

    <form
      [formGroup]="vop_new_check_from_group"
      class="sp-column">
      <mat-form-field
        class="sp-width__full sp-margin__bottom-x2"
        appearance="fill"
        color="accent">
        <mat-label> {{ 'BUYERS.FIRSTNAME_LABEL' | translate }} </mat-label>
        <input
          matInput
          type="text"
          formControlName="beneficiary_firstname"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-margin__bottom-x2"
        appearance="fill"
        color="accent">
        <mat-label> {{ 'BUYERS.LASTNAME_LABEL' | translate }} </mat-label>
        <input
          matInput
          type="text"
          formControlName="beneficiary_lastname"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-margin__bottom-x2"
        appearance="fill"
        color="accent">
        <mat-label> {{ 'BUYERS.TAX_CODE_LABEL' | translate }} </mat-label>
        <input
          matInput
          type="text"
          formControlName="beneficiary_tax_code"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-margin__bottom-x2"
        appearance="fill"
        color="accent">
        <mat-label> {{ 'ORDERS.IBAN_LABEL' | translate }} </mat-label>
        <input
          matInput
          type="text"
          formControlName="iban"
          required
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <app-shared-button
        class="sp-width__full"
        [button_class]="'sp-button__main'"
        [spinner_class]="'sp-spinner__main'"
        [cta]="'GENERAL.CONFIRM_CTA'"
        [is_disabled]="is_check_running"
        [is_spinner_visible]="is_check_running"
        (click)="onConfirmClick()"></app-shared-button>
    </form>
  </div>
</div>
